import $ from 'jquery';
import { scrollToId } from './scrollTo';
import * as pagination from './pagination';
import * as loader from './loader';
import { buildUrl, setSearchParam, bussinessEnergyQueryStringKeys } from './search';
import { MQ } from '../tools/MQ.js';
import * as stickyFilter from './stickyFilter';

export const init = () => {
	const $heroSticky = $('.hero .sticky-component'),
		$businessEnergyList = $('.js-business-energy-list');

	if (!$businessEnergyList.length || !$heroSticky.length) {
		return;
	}

	///////////////////////////////////////////////////////////////////////////////
	/// CONSTANTS AND VARIABLES
	///////////////////////////////////////////////////////////////////////////////

	const CATEGORY_URL_KEY = 'category',
		ALL_CATEGORY_VALUE = 'all',
		BUSINESS_ENERGY_LIST_ID = '#business-energy-list',
		URL_KEY = 'category',
		urlSearchParams = new URLSearchParams(window.location.search),
		$filterBtn = $heroSticky.find('.btn'),
		$loader = $('.article-card__container .js-loader'),
		BUSINESS_ENERGY_API = '/api/BusinessEnergyListSection/articleCards',
		CARDS_ON_DESKTOP = 9,
		CARDS_ON_TABLET = 8,
		CARDS_ON_MOBILE = 3,
		$dropdown = $heroSticky.find('.js-dropdown');

	///////////////////////////////////////////////////////////////////////////////
	/// INITIALIZATION
	///////////////////////////////////////////////////////////////////////////////

	initPagination();
	initFilter();

	$filterBtn.on('click', function () {
		const selectedCategoryCodeName = stickyFilter.getDropdownSelectedItemCodeName($dropdown);

		stickyFilter.updateSearchUrl(selectedCategoryCodeName, urlSearchParams, URL_KEY);
		filterShownCategories(1, selectedCategoryCodeName);
		scrollToId(BUSINESS_ENERGY_LIST_ID);
	});

	///////////////////////////////////////////////////////////////////////////////
	/// HELPERS
	///////////////////////////////////////////////////////////////////////////////

	function initPagination() {
		pagination.init(BUSINESS_ENERGY_LIST_ID, onPaginationChange);
		pagination.show();

		function onPaginationChange(page) {
			filterShownCategories(page, stickyFilter.getDropdownSelectedItemCodeName($dropdown));
		}
	}

	function initFilter() {
		var selectedCategoryCodeName = urlSearchParams.get(CATEGORY_URL_KEY);

		if (selectedCategoryCodeName === null) {
			selectedCategoryCodeName = ALL_CATEGORY_VALUE;
		}

		filterShownCategories(1, selectedCategoryCodeName);
		stickyFilter.selectDropdownItem(selectedCategoryCodeName, $dropdown, urlSearchParams, URL_KEY);
	}

	async function filterShownCategories(page, selectedCategoryCodeName) {
		let pageSize = CARDS_ON_DESKTOP;
		if (MQ('lgDown')) {
			pageSize = CARDS_ON_TABLET;
		}
		if (MQ('smDown')) {
			pageSize = CARDS_ON_MOBILE;
		}

		if (selectedCategoryCodeName === ALL_CATEGORY_VALUE) {
			selectedCategoryCodeName = '';
		}

		loader.show($loader);

		try {
			var response = await downloadArticles(page, selectedCategoryCodeName, pageSize);
		} catch (err) {
			if (err.status !== '404') console.error(err);
		}

		fillArticleSection(response.articleCards);

		const totalPages = Math.max(1, Math.ceil(parseInt(response.totalPages) / pageSize));
		pagination.update(page, totalPages);

		loader.hide($loader);
	}

	function downloadArticles(page, category, pageSize) {
		const urlSearchParams = new URLSearchParams();
		setSearchParam(urlSearchParams, bussinessEnergyQueryStringKeys.pageIndex, page - 1);
		setSearchParam(urlSearchParams, bussinessEnergyQueryStringKeys.pageSize, pageSize);

		var url = buildUrl(BUSINESS_ENERGY_API + '/' + category, urlSearchParams);

		return $.ajax({
			type: 'GET',
			url: url,
			contentType: 'text/plain',
		});
	}

	function fillArticleSection(articleCards) {
		const articleSection = articleCards.map(
			(articleCard) => `
			<div class="grid__col col-4-12@lg col-6-12@sm">
				<div class="article-card">
					<div class="article-card__info">
						<div class="tag">
							<span class="tag__text">${articleCard.categoryTitle}</span>
						</div>
						<div class="tag__read-time">
							<span class="tag__stopwatch">
								<span aria-hidden="true" class="icon-svg icon-svg--stopwatch "><svg class="icon-svg__svg" xmlns:xlink="http://www.w3.org/1999/xlink"><use focusable="false" height="100%" width="100%" xlink:href="/img/bg/icons-svg.svg#icon-stopwatch"></use></svg></span>
							</span>
							<div class="tag__read-time-text">
								<span>${articleCard.readTime}. min čtení</span>
							</div>
						</div>
					</div>

					<div class="article-card__image-wrap js-objectfit">
						<img loading="lazy" src="${articleCard.imageUrl}">
					</div>
					<div class="article-card__content">
						<h3 class="article-card__title">${articleCard.title}</h3>
						<p class="article-card__perex">${articleCard.perex}</p>
						<a href=${articleCard.articleUrl} class="article-card__link item-icon">
							<span class="item-icon__icon"> <span aria-hidden="true" class="icon-svg icon-svg--arrow-right "><svg class="icon-svg__svg" xmlns:xlink="http://www.w3.org/1999/xlink"><use focusable="false" height="100%" width="100%" xlink:href="/img/bg/icons-svg.svg#icon-arrow-right"></use></svg></span></span>
							<span class="item-icon__text">Čtěte více</span>
							<span class="article-card__border"></span>
						</a>
					</div>
				</div>
			</div>`,
		);

		$($businessEnergyList).html(articleSection);
	}
};
